import { staffItineraryDetailSchema, staffItineraryOutcomeSchema, staffItineraryRevisionsSchema, staffItineraryValidationSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createStaffItineraryApi(options) {
    const send = createMemoryTransport(options);
    const id = encodeURIComponent;
    const command = (path, body, commandOptions) => send({
        method: "POST",
        path,
        body,
        schema: staffItineraryOutcomeSchema,
        idempotencyKey: commandOptions?.idempotencyKey,
        signal: commandOptions?.signal,
    });
    return {
        listRevisions: async (tripId, callOptions) => (await send({
            method: "GET",
            path: `/staff/trips/${id(tripId)}/itineraries`,
            schema: staffItineraryRevisionsSchema,
            signal: callOptions?.signal,
        })).items,
        getDetail: (itineraryId, callOptions) => send({
            method: "GET",
            path: `/staff/itineraries/${id(itineraryId)}`,
            schema: staffItineraryDetailSchema,
            signal: callOptions?.signal,
        }),
        createPlan: (body, commandOptions) => command("/staff/itineraries", body, commandOptions),
        editDraft: (itineraryId, body, commandOptions) => command(`/staff/itineraries/${id(itineraryId)}/operations`, body, commandOptions),
        edit: (tripId, body, commandOptions) => command(`/staff/trips/${id(tripId)}/itinerary/edits`, body, commandOptions),
        activate: (itineraryId, body, commandOptions) => command(`/staff/itineraries/${id(itineraryId)}/activate`, body, commandOptions),
        archive: (itineraryId, body, commandOptions) => command(`/staff/itineraries/${id(itineraryId)}/archive`, body, commandOptions),
        validate: (itineraryId, callOptions) => send({
            method: "POST",
            path: `/staff/itineraries/${id(itineraryId)}/validate`,
            body: callOptions?.body ?? {},
            schema: staffItineraryValidationSchema,
            signal: callOptions?.signal,
        }),
    };
}
